export interface RouteAccessRule {
  publicAccess?: boolean;
  requiresPermission?: {
    resource: string;
    action: string;
  };
}

// Access rules for routes that are NOT displayed in the main sidebar menu
// but should still be accessible via navbar/user dropdown or deep links
export const ROUTE_ACCESS: Record<string, RouteAccessRule> = {
  '/settings': {
    publicAccess: true, // any authenticated user can access their settings
  },
  '/notifications': {
    requiresPermission: { resource: 'notifications', action: 'read' },
  },
  '/system-logs': {
    requiresPermission: { resource: 'audit_logs', action: 'read' },
  },
};
